import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useDocumentTitle from '../../../components/useDocumentTitle';
import logo from "../../../assets/img/avatars/avatar_1.png";
import { getFractionalNFTDetails, getFractionalNFTFromContract, getFractionalNFTFromLocal, listActiveFractionalNFTs } from '../../../hooks/FNFThook';
import { getNftData } from '../../../hooks/Tokenhook';

const AllFNFT = () => {
  useDocumentTitle('FNFT');
  const walletAddress = localStorage.getItem("WalletAddress");
  const [NFTsforCollection, setNFTforCollection] = useState([]);

  useEffect(() => {
    GetAllMintedNFT();
  }, [walletAddress]);

  const GetAllMintedNFT = async () => {
    const params = {
      isFundingActive: true,
      sortBy : "createdAt",
  }
    const response = await listActiveFractionalNFTs();
    // console.log("");
    setNFTforCollection(response.data);
    response.data.map(async (data) => {
      const NFTdata = await getFractionalNFTFromLocal(data.fractionNftId)
      console.log("NFTdata", NFTdata);
    })
  };

  const handleError = (event) => {
    event.target.src = logo;
  };

  console.log(NFTsforCollection);

  return (
    <div className="container" >
      <div className="row">
        {NFTsforCollection.length !== 0 && NFTsforCollection.map((val, i) => (
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6" key={i}>
            <Link to={`/item-details/${val._id}`}>
              <div className="card__item four">
                <div className="card_body space-y-10">
                  <div className="creators space-x-10">
                    <div className="avatars space-x-3">
                      <Link to={`/profile/${val.creator}`}>
                        <img
                          src={val.creatorprofilePicture}
                          alt=""
                          className="avatar avatar-sm"
                          onError={handleError}
                        />
                      </Link>
                      <Link to={`/profile/${val.creator}`}>
                        <p className="avatars_name txt_xs">
                          {val.creatorName}
                        </p>
                      </Link>
                    </div>
                  </div>
                  <div className="card_head">
                    <img src={val.image} alt="nft image" onError={handleError} />
                    <div className="likes space-x-3">
                      <i className="ri-heart-3-line" />
                      <span className="txt_sm">{val.totalLikes}</span>
                    </div>
                  </div>

                  <div className="card_footer d-block space-y-10">
                    <div
                      className="d-flex align-items-center space-x-10 justify-content-between">
                      <div
                        className="d-flex align-items-center space-x-5">
                        <h6 className="card_title">
                          <div className="color_black" style={{ textTransform: "capitalize" }}>
                            {val.title}
                          </div>
                        </h6>
                      </div>
                      <div className="txt_sm">
                        Price:{" "}
                        <span className="color_green txt_sm">
                          {val.price} ETH
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllFNFT;
